import styled from 'styled-components';
import { CloseIcon } from '@components/Modal/WhatsNew/icons/Close';

const ModalWrapper = styled.div`
  background: #e4ebf5;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  position: relative;
  padding: 0;
  max-width: 800px;
  text-align: left;
  color: #40608f;

  h2 {
    background: linear-gradient(90deg, #7aabf3 0%, #2765be 100%);
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: 0.01em;
    text-align: left;
    padding: 20px 30px;
    border-radius: 5px 5px 0 0;
  }

  .close-icon {
    position: absolute;
    top: 22px;
    right: 30px;
    cursor: pointer;
  }

  .hammer {
    position: absolute;
    top: 30px;
    left: 0;
    z-index: 1;
  }

  .content {
    position: relative;
    padding: 20px 30px 30px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    z-index: 10;
  }

  .description {
    padding: 20px 0 25px;
  }

  .link {
    display: block;
    text-align: right;
    a {
      font-size: 12px;
      font-weight: 500;
      line-height: 15.6px;
      text-decoration: underline;
      color: #40608f;
    }
  }
`;

type TProps = {
  onCancel: () => void;
};

export const WhatsNewModal = ({ onCancel }: TProps) => {
  return (
    <ModalWrapper>
      <h2>What’s new</h2>
      <CloseIcon className="close-icon" onClick={onCancel} />

      <svg
        className="hammer"
        width="165"
        height="242"
        viewBox="0 0 165 242"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="44" cy="121" r="121" fill="white" fillOpacity="0.1" />
        <path
          d="M54.8379 59.0277C53.5349 57.2304 51.8583 55.7376 49.9239 54.6522C47.9894 53.5668 45.843 52.9147 43.6328 52.7407C41.4225 52.5668 39.2008 52.8752 37.1209 53.6446C35.0411 54.4141 33.1525 55.6263 31.5854 57.1977L7.97848 80.8578C6.37413 82.4647 5.1456 84.4082 4.38145 86.5483C3.61731 88.6884 3.3366 90.9716 3.55954 93.2336C3.78249 95.4955 4.50354 97.6796 5.67072 99.6286C6.83789 101.578 8.42212 103.243 10.3092 104.504L24.0072 113.647L-22.8318 159.691C-24.4936 161.259 -25.8253 163.144 -26.7485 165.236C-27.6717 167.328 -28.1676 169.584 -28.2072 171.871C-28.2467 174.158 -27.8289 176.429 -26.9786 178.552C-26.1282 180.675 -24.8624 182.605 -23.2558 184.23C-21.6491 185.855 -19.7341 187.141 -17.6237 188.013C-15.5132 188.885 -13.2499 189.324 -10.9673 189.306C-8.68456 189.288 -6.42862 188.812 -4.33236 187.906C-2.2361 187.001 -0.341934 185.684 1.23852 184.034L48.0707 137.109L56.3576 150.151C57.5897 152.094 59.2416 153.734 61.1912 154.951C63.1408 156.168 65.3384 156.93 67.6216 157.182C69.9048 157.434 72.2152 157.168 74.3823 156.405C76.5493 155.642 78.5176 154.401 80.1417 152.773L103.558 129.311C105.125 127.741 106.334 125.849 107.101 123.766C107.868 121.683 108.176 119.458 108.002 117.244C107.828 115.03 107.178 112.881 106.095 110.943C105.013 109.005 103.524 107.326 101.731 106.02L75.235 86.7096C74.8008 86.3936 74.419 86.0111 74.1037 85.5761L54.8379 59.0277ZM38.8228 64.4357C39.3454 63.9137 39.9746 63.5113 40.6672 63.2562C41.3598 63.001 42.0993 62.8991 42.8349 62.9575C43.5705 63.0159 44.2847 63.2332 44.9286 63.5944C45.5724 63.9557 46.1305 64.4523 46.5646 65.0502L49.6994 69.3657L20.2726 98.8367L15.9792 95.9688C15.3506 95.5483 14.8228 94.9933 14.434 94.3439C14.0452 93.6944 13.805 92.9667 13.7307 92.213C13.6564 91.4593 13.7498 90.6985 14.0043 89.9854C14.2588 89.2723 14.6679 88.6246 15.2023 88.0889L38.816 64.4289L38.8228 64.4357ZM28.9412 104.641L55.7852 77.7509L65.8372 91.5987C66.7844 92.8961 67.9225 94.0432 69.2174 94.9924L82.5746 104.709L56.3235 131.005L49.1406 119.69C47.995 117.887 46.4863 116.342 44.7109 115.156L28.9412 104.641ZM61.939 139.868L90.9365 110.814L95.7206 114.296C96.3196 114.731 96.8173 115.291 97.1792 115.937C97.5412 116.583 97.7589 117.301 97.8172 118.039C97.8755 118.778 97.7731 119.521 97.517 120.216C97.2609 120.912 96.8573 121.543 96.334 122.067L72.9111 145.529C72.3702 146.071 71.7146 146.485 70.9928 146.739C70.271 146.994 69.5013 147.083 68.7406 147C67.9799 146.917 67.2475 146.663 66.5975 146.259C65.9476 145.854 65.3966 145.308 64.9853 144.661L61.939 139.868ZM42.4484 128.26L-5.99211 176.795C-6.62609 177.469 -7.38881 178.007 -8.23482 178.379C-9.08083 178.75 -9.99283 178.947 -10.9165 178.958C-11.8401 178.969 -12.7565 178.794 -13.6111 178.442C-14.4657 178.091 -15.2409 177.571 -15.8906 176.913C-16.5404 176.255 -17.0513 175.473 -17.393 174.613C-17.7346 173.753 -17.9001 172.833 -17.8794 171.908C-17.8588 170.983 -17.6524 170.071 -17.2727 169.227C-16.893 168.383 -16.3477 167.625 -15.6693 166.997L32.6894 119.451L39.0273 123.685C39.6203 124.081 40.1241 124.598 40.5061 125.201L42.4484 128.253V128.26ZM58.995 168.417C57.6394 168.417 56.3394 168.957 55.3808 169.917C54.4223 170.878 53.8838 172.18 53.8838 173.538C53.8838 174.897 54.4223 176.199 55.3808 177.16C56.3394 178.12 57.6394 178.66 58.995 178.66H45.3652C44.0096 178.66 42.7095 179.199 41.751 180.16C40.7925 181.12 40.254 182.423 40.254 183.781C40.254 185.139 40.7925 186.442 41.751 187.402C42.7095 188.363 44.0096 188.902 45.3652 188.902H103.292C104.648 188.902 105.948 188.363 106.906 187.402C107.865 186.442 108.403 185.139 108.403 183.781C108.403 182.423 107.865 181.12 106.906 180.16C105.948 179.199 104.648 178.66 103.292 178.66H89.6621C91.0177 178.66 92.3178 178.12 93.2763 177.16C94.2348 176.199 94.7733 174.897 94.7733 173.538C94.7733 172.18 94.2348 170.878 93.2763 169.917C92.3178 168.957 91.0177 168.417 89.6621 168.417H58.995Z"
          fill="white"
          fillOpacity="0.5"
        />
      </svg>

      <div className="content">
        <p className="date underline">New AutoScript Feature Release: November 18, 2024</p>
        <p className="description">
          <strong>Workspace Notifications: </strong>
          <li>
            Owners and Operations members can now monitor a workspace to receive updates on any job within it. Select
            whether editors and proofers should receive notifications when a new job is created in the workspace.
          </li>
          <strong>Control Workspace Notifications:</strong>
          <li>
            Navigate to the Organization Details page and click the &quot;Watch&quot; button to enable notifications for
            a specific workspace.
          </li>
          <li>
            To prevent editors and proofers from receiving claim notifications for new jobs, uncheck the &quot;Enable
            notifications for Editor&quot; and &quot;Enable notifications for Proofer&quot; options.
          </li>
          <strong>Auto Top-Up:</strong>
          <li>
            Ensure uninterrupted workflow by enabling automatic top-ups. This feature will automatically replenish your
            account balance when it drops below a specified threshold. AutoTopUp can be accessed in the Billing Account
            Details page.
          </li>
        </p>

        <p className="link">
          <a href="https://support.voicescript.ai/portal/en/home" rel="noreferrer" target="_blank">
            Read more »
          </a>
        </p>
      </div>
    </ModalWrapper>
  );
};
